/**
 * 실행계획이 읽는 객체와 그 **소유자**(2026-10-13).
 *
 * DBMS_XPLAN 의 글에는 소유자가 없다 — 그래서 오브젝트 상세가 같은 이름의 테이블을 접속 계정이 볼 수 있는 모든 스키마에서
 * 찾아 늘어놓았다. 서버가 계획 표(V$SQL_PLAN)에서 소유자를 읽어 첫 줄의 `PLAN_OBJECTS` 에 실어 주고, 여기서 그것을 꺼내 쓴다.
 * 못 받았으면(다른 DBMS · 권한 없음 · 보관함에서 연 옛 계획) 빈 목록이고 화면은 예전처럼 이름으로만 찾는다.
 */

/** 서버 응답의 줄들 → [{ owner, name, type }] */
export function planObjectsOf(rows) {
  const first = Array.isArray(rows) ? rows[0] : null;
  const list = first && Array.isArray(first.PLAN_OBJECTS) ? first.PLAN_OBJECTS : [];
  return list.filter(o => o && o.owner && o.name).map(o => ({ owner: String(o.owner), name: String(o.name), type: o.type || null }));
}

/**
 * 이름 → 소유자. **한 소유자로 정해지는 이름만** 담는다 — 같은 이름이 두 스키마에서 함께 읽히면 어느 것인지 알 수 없다
 * (그때는 화면이 예전처럼 스키마를 고르게 둔다).
 */
export function ownerByName(planObjects) {
  const owners = new Map();
  for (const o of planObjects || []) {
    const key = String(o.name).toUpperCase();
    if (!owners.has(key)) owners.set(key, new Set());
    owners.get(key).add(o.owner);
  }
  const out = new Map();
  for (const [name, set] of owners) if (set.size === 1) out.set(name, [...set][0]);
  return out;
}

/** 서버에 보낼 이름 — 소유자를 알면 `OWNER.NAME`, 모르면 이름만 */
export function qualify(name, owners) {
  const n = String(name || '').toUpperCase();
  const o = owners && owners.get(n);
  return o ? `${o}.${n}` : n;
}
